// extracted by mini-css-extract-plugin
export var borderRadius = "_gl-4";
export var large = "_gl-3";
export var logoContainer = "_gl-0";
export var nameLogo = "_gl-2";
export var small = "_gl-1";